import React, { useEffect, useMemo, useState } from 'react';
import { ReactComponent as EyeIcon } from '../../../../assets/icons/svg/shared/ic-shared-eye-opened.svg';
import { useStore } from '../../../../store';
import { useDownloadCheckPhotoMutation } from '../../../../hooks/mutations/useDownloadCheckPhotoMutation';
import Button from '../../../../generic-components/Button';
import Icon from '../../../../generic-components/Icon';
import { UserMessage } from '../../../../DesignSystem/LiliUserMessage/UserMessage';

import leftArrow from '../../../../assets/svg/arrowLeft.svg';
import rightArrow from '../../../../assets/svg/arrowRight.svg';
import downloadIcon from '../../../../assets/svg/download-icon.svg';
import { CloseButton } from '../../../../DesignSystem/LiliCloseButton/CloseButton';

/* eslint-disable */
interface IProps {
  className: string;
  transactionId: string;
}

const CheckPhoto = ({ className, transactionId }: IProps) => {
  const [isPhotoShown, setIsPhotoShown] = useState<boolean>(false);
  const [imageIndex, setImageIndex] = useState<number>(0);
  const { customerId } = useStore((state) => state.user);
  const {
    data: frontPhoto,
    mutate: getFrontPhoto,
    isLoading,
  } = useDownloadCheckPhotoMutation({
    customerId,
    transactionId,
    checkSide: true,
  });
  const { data: rearPhoto, mutate: getRearPhoto } = useDownloadCheckPhotoMutation({
    customerId,
    transactionId,
    checkSide: false,
  });
  const imageUrls = useMemo(() => [frontPhoto, rearPhoto], [frontPhoto, rearPhoto]);
  const handleDownload = (url: string | undefined) => {
    if (url) {
      const a = document.createElement('a');
      a.href = url;
      a.download = imageIndex === 0 ? 'front_check' : 'rear_check';
      a.click();
      document.removeChild(a);
    }
  };

  useEffect(() => {
    if (!transactionId) return;
    Promise.all([getFrontPhoto(), getRearPhoto()]);
  }, [transactionId]);

  return (
    <div className={className}>
      <div id='transactionDetailsCheckPhoto' className='font-metricSemibold text-base text-bw08'>
        Check Photo
      </div>
      <Button
        disable={isLoading}
        id='openCheckPhoto'
        onClick={() => {
          setIsPhotoShown(!isPhotoShown);
        }}
        childElement={<EyeIcon className={`${isLoading ? 'opacity-70' : ''} text-bw07`} />}
        className=''
      />
      {isPhotoShown && (
        <UserMessage
          id='checkPhotoUserMessage'
          contentWrapperClassName='bg-opacity-0'
          onClick={() => {
            setIsPhotoShown(!isPhotoShown);
          }}
          children={
            <div className='fixed top-0 left-0 w-screen h-screen bg-bw08 bg-opacity-95 flex flex-col items-center'>
              <div className='flex bg-bw08 rounded-lg justify-between items-center w-[1110px] h-[70px]'>
                <div id='transactionDetailsViewCheck' className='text-base font-metricSemibold text-bw00 ml-[30px]'>
                  View Check
                </div>
                <div>
                  <Button
                    id='checkPhotoHandleDownload'
                    onClick={() => {
                      handleDownload(imageUrls[imageIndex]);
                    }}
                    childElement={<Icon iconId='download' src={downloadIcon} />}
                    className=''
                  ></Button>
                  <CloseButton
                    onClick={() => setIsPhotoShown(!isPhotoShown)}
                    id='closeCheckPhoto'
                    className='mr-[20px]'
                  />
                </div>
              </div>
              <div className='flex gap-20 h-full'>
                <Button
                  id='checkPhotoGoLeft'
                  onClick={() => {
                    setImageIndex(0);
                  }}
                  childElement={<Icon src={leftArrow} />}
                  className=''
                ></Button>
                <img
                  id='transactionDetailsCheckImage'
                  className='w-full object-contain'
                  src={imageUrls[imageIndex]}
                  alt='check_photo'
                />
                <Button
                  id='checkPhotoGoRight'
                  onClick={() => {
                    setImageIndex(1);
                  }}
                  childElement={<Icon src={rightArrow} />}
                  className=''
                ></Button>
              </div>
            </div>
          }
        />
      )}
    </div>
  );
};

export default CheckPhoto;
